import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getDevelopmentStepByStep(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Cíl",
			desc: "sp[[Ujasníme]] si s klientem zadání, rozpočet a další klíčové detaily.",
		},
		{
			title: "Zadání",
			desc: "Dáme dohromady uživatelské příběhy nebo požadavky na systém a sp[[rozdělíme zadání do tzv. sprintů.]] Jeden sprint trvá v průměru 14 dnů.",
		},
		{
			title: "MVP",
			desc: "Sestavíme priority z hlediska byznysu i technologie. Společně si sp[[definujeme MVP]] (Minimum viable product – minimální použitelný produkt).  ",
		},
		{
			title: "Vývoj",
			desc: "Náš IT tým sp[[pracuje]] na jednotlivých sprintech. Po celou dobu komunikujeme s klientem, který má v průběhu vývoje přístup k testování.",
		},
		{
			title: "Spuštění",
			desc: "sp[[Spustíme MVP]] (minimální použitelný produkt). Plánujeme další rozvoj, řadíme priority a vyhodnocujeme MVP.",
		},
		{
			title: "Údržba",
			desc: "V průběhu času provádíme sp[[pravidelnou aktualizaci a údržbu]] software.",
		},
	];
}
